<template>
  <div
    :class="{'mx-2': !root, 'px-3': !root}"
    class="rounded"
  >
    <div
      v-if="rule.name && isRulesFieldVisible('ruleName')"
      class="pb-2"
    >
      {{ rule.name }}
    </div>
    <FormWysiwyg
      v-if="rule.description && isRulesFieldVisible('ruleDescription')"
      :disabled="true"
      class="py-2 ruleDescriptionViewer"
      :value="rule.description"
    />
    <strong v-if="shouldShowStrongDisplay">
      {{ displayString }}</strong>
    <span v-else>{{ displayString }} </span>
    <div
      v-if="shouldShowDataSelect"
      class="mx-2"
    >
      <SimpleRequisiteDataSelectDisplay :selection="rule.value" :titleInterpolation="titleInterpolation" />
    </div>
    <FormWysiwyg
      v-if="rule.notes"
      :disabled="true"
      class="py-2"
      :value="rule.notes"
    />
    <div class="d-flex">
      <AppButton
        v-if="!disabled && isRulesFieldVisible('editRule')"
        class="ml-auto"
        @click="$emit('edit')"
      >
        <AppIcon
          name="edit"
          class="mr-1"
        />
        Edit
      </AppButton>
    </div>
  </div>
</template>

<script>
import SimpleRequisiteDataSelectDisplay from './SimpleRequisiteDataSelectDisplay'
import FormWysiwyg from '@/components/Forms/FormWysiwyg'
import { requisiteUtils } from '@coursedog/requisites'
const reqUtil = requisiteUtils()
const STRONG_DISPLAY_OPTIONS = [
  'anyOf',
  'allOf',
  'numberOf',
  'enrolledIn',
  'completed',
  'completedAllOf',
  'completedAnyOf',
  'completedAtLeastXOf',
  'completeVariableCoursesAndVariableCredits',
]
export default {
  name: 'SimpleRequisiteDisplay',
  components: { SimpleRequisiteDataSelectDisplay, FormWysiwyg },
  props: {
    rule: {
      type: Object,
      required: true,
    },
    root: {
      type: Boolean,
      default: false,
    },
    depth: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    isRulesFieldVisible: {
      type: Function,
      default: () => false,
    },
    titleInterpolation: {
      type: String,
      default: '',
    },
  },
  computed: {
    shouldShowDataSelect () {
      return reqUtil.shouldShowDataSelect(this.rule)
    },
    shouldShowStrongDisplay () {
      return STRONG_DISPLAY_OPTIONS.includes(this.rule.condition)
    },
    displayString () {
      return reqUtil.simpleRequisiteDisplayString(this.rule)
    },
  },
}
</script>
